/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MarketplaceLeadsBuyOrderRequestApiModel } from '../../models/marketplace-leads-buy-order-request-api-model';

export interface CreateBuyOrder$Params {
      body: MarketplaceLeadsBuyOrderRequestApiModel
}

export function createBuyOrder(http: HttpClient, rootUrl: string, params: CreateBuyOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<MarketplaceLeadsBuyOrderRequestApiModel>> {
  const rb = new RequestBuilder(rootUrl, createBuyOrder.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MarketplaceLeadsBuyOrderRequestApiModel>;
    })
  );
}

createBuyOrder.PATH = '/marketplace/purchase';
